<div class="member-registration-thank-you align-items-center heightContent100">

    <div class="text-center mx-auto">
        <h4 class="py-2">Complete your registration to start enjoying the benefits of Fitness Passport !</h4>
        <div class="pt-3">
            <button class="px-5 py-2 btn btn-primary" (click)="ContinueRegistration()">CONTINUE REGISTRATION</button>
        </div>
    </div>
</div>